import React from 'react';
import Modal from 'components/UI/DialogModal';
import { CircularProgress, Grid, Typography } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}




const DeleteCity: React.FC<Props> = ({ open, loading, onClose, onSubmit }) => {
  const { t } = useTranslation();
  return (<>
    <Modal
      open={open}
      onClose={onClose}
      title={t('T_delete_city')}
      maxWidth="lg"
      children={<Grid container p={2}>
        <Typography variant="h6">{t('T_delete_city_confirm')}</Typography>
      </Grid>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="outlined"
            sx={{ color: 'warning.main', borderColor: 'warning.main' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'error.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_delete')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default DeleteCity;
